/*
 * @Author: huangzq
 * @Date: 2019-10-20 23:01:53
 * @Last Modified by: huangzq
 * @Last Modified time: 2019-10-20 23:04:17
 * @Desc: Storage的相关操作
 */
// storage.getItem
const getItem = (key: string, storage = window.sessionStorage) => {
  const data = JSON.parse(storage.getItem(key) || 'null');
  /**
   * 如果取用户信息
   * 1. 这里需要兼容 uniapp 的缓存格式 {data: {}, type: 'object'}
   * 2. 还有可能在 localStorage 中(其他项目过来的)
   *  */
  if (key === 'authUserInfo') {
    // 其他项目过来的 授权后的参数格式不对 删除授权的 token 重新拉起授权 排查的场景如下：
    // 只要 sessionStorage 中有 authUserInfo 就说明是 authSdk 授权过来的 不处理
    // 没有 authUserInfo 就说明其他行吗自行处理的授权 这时候需要删除授权的 token 重新拉起授权
    if (!data) {
      sessionStorage.removeItem('token');
    }
  }
  return data;

};

// storage.setItem
const setItem = (key: any, value: any, storage = window.sessionStorage) => {
  storage.setItem(key, JSON.stringify(value));
};

// storage.removeItem
const removeItem = (key: string, storage = window.sessionStorage) => {
  storage.removeItem(key);
};

export default { getItem, setItem, removeItem };
